import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps,
  Box,
  Tooltip,
  Zoom,
} from '@mui/material';
import {useFormikContext} from 'formik';
import React from 'react';

interface CustomSelectProps {
  name: string;
  label: string;
  value: string | number;
  error?: boolean;
  helperText?: string;
  children: React.ReactNode;
  onChange: any;
  onBlur?: SelectProps['onBlur'];
  tooltiptitle?: string;
}

export function CustomSelect({
  name,
  value,
  label,
  error,
  helperText,
  children,
  onChange,
  onBlur,
}: CustomSelectProps) {
  const labelId = `${name}Label`;

  return (
    <FormControl variant="filled" error={error} fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        id={name}
        name={name}
        value={value}
        fullWidth
        onChange={onChange}
        onBlur={onBlur}
        variant="outlined"
      >
        {children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

type FormikCustomSelectProps = Omit<
  CustomSelectProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'helperText'
>;

export function FormikCustomSelect(props: FormikCustomSelectProps) {
  const {name, tooltiptitle = ''} = props;
  const formik = useFormikContext();
  const meta = formik.getFieldMeta(name);

  return (
    <Tooltip
      title={tooltiptitle}
      TransitionComponent={Zoom}
      TransitionProps={{timeout: 300}}
      placement="left"
      arrow
    >
      <Box>
        <CustomSelect
          {...formik.getFieldProps(name)}
          error={meta.touched && Boolean(meta.error)}
          helperText={(meta.touched && meta.error) || ''}
          {...props}
        />
      </Box>
    </Tooltip>
  );
}
